import Blue from "~/core";

new Blue({
  name: "Illegal Dumping Report Form Admin",
  selector: ".illegal-dumping-report-admin",
  setup(form) {
    function renderStaticMap() {
      var map;
      var mylatlng;
      var gmapElement = document.getElementById("gmap");
      var lat = parseFloat(gmapElement.dataset.lat);
      var lng = parseFloat(gmapElement.dataset.long);
      var reportCoordinates = new google.maps.LatLng(lat, lng);

      mylatlng = new google.maps.LatLng(32.838, -97.000);

      var myOptions = {
        zoom: 9,
        center: mylatlng,
        streetViewControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      map = new google.maps.Map(document.getElementById("gmap"), myOptions);

      const marker = new google.maps.Marker({
        map: map,
        position: reportCoordinates,
        title: "Illegal Dumping Site"
      });

      document.getElementById("mapNotes").innerHTML =
        `(${reportCoordinates.lat()}, ${reportCoordinates.lng()})<br>` +
        "*Marker may not be exact due to Google Maps rounding coordinates.";
    }

    function setupAddNotesOnBehalfOfButton() {
      const addNotesOnBehalfOfButton = document.querySelector('#addNotesOnBehalfButton');

      if(addNotesOnBehalfOfButton){
        addNotesOnBehalfOfButton.addEventListener('click', function() {
          const actionsTakenElement = document.querySelector('.illegal-dumping-report__actionsTaken');
          if (actionsTakenElement) {
            actionsTakenElement.style.display = 'flex';
          }
        });
      }
    }

    function setupDeleteButtonValidation() {
      const invalidReportCheckbox = document.querySelector('#invalid-report-checkbox');
      const deleteReportButton = document.querySelector('#delete-report');

      if(invalidReportCheckbox && deleteReportButton){
        deleteReportButton.disabled = !invalidReportCheckbox.checked;

        invalidReportCheckbox.addEventListener('change', function() {
          deleteReportButton.disabled = !invalidReportCheckbox.checked;
        });
      }
    }

    function setupDeleteButtonOnclick() {
      const deleteReportButton = document.querySelector('#delete-report');

      if(deleteReportButton){
        deleteReportButton.addEventListener('click', function() {

          this.disabled = true;
  
          const urlParams = new URLSearchParams(window.location.search);
          const trackingId = urlParams.get('trackingId');      
          const baseUrl = window.location.origin;
          const deleteReportEndpoint = `${baseUrl}/api/rid-admin/delete-report`;
  
          fetch(deleteReportEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(trackingId),
          })
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
            })
            .then(() => {
              alert('Report successfully deleted');
              window.location.reload();
            })
            .catch(error => {
              alert('Failed to delete report. Please try again.', error.message);
            })
            .finally(() => {
              this.disabled = false;
            });
        });
      } 
    }

    function setupOutsideRegionButtonValidation() {
      const outsideRegionCheckbox = document.querySelector('#outside-region-checkbox');
      const outsideRegionButton = document.querySelector('#outside-region');

      if(outsideRegionCheckbox && outsideRegionButton){
        outsideRegionButton.disabled = !outsideRegionCheckbox.checked;

        outsideRegionCheckbox.addEventListener('change', function() {
          outsideRegionButton.disabled = !outsideRegionCheckbox.checked;
        });
      }
    }

    function setupOutsideRegionButtonOnclick() {
      const outsideRegionButton = document.querySelector('#outside-region');

      if(outsideRegionButton){
        outsideRegionButton.addEventListener('click', function() {
          this.disabled = true;
  
          const actionsTakenTextarea = document.querySelector('.illegal-dumping-report__actionsTaken textarea');
          if (actionsTakenTextarea) {
              const date = new Date();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              const year = date.getFullYear();
              const currentDate = `${month}-${day}-${year}`;
            actionsTakenTextarea.value = actionsTakenTextarea.value + `Unfortunately, the report you made on ReportDFWDumping.org is unable to be passed along, as this location is outside of the Dallas-Fort Worth region in Texas. We do not house any information for jurisdictions outside of this region. Please reach out to your local authorities and code enforcement to help remediate your issue. Thank you. -- Case Closed on ${currentDate}`;
          }
          submitActionTakenUpdates.call(this);
        });
      } 
    }

    function setupRelinkJurisdictionButtonOnClick() {
      const relinkJurisdictionButton = document.querySelector('#relink-jurisdiction');

      if(relinkJurisdictionButton){
        relinkJurisdictionButton.addEventListener('click', function() {
          this.disabled = true;
          
          const urlParams = new URLSearchParams(window.location.search);
          const trackingId = urlParams.get('trackingId');
          
          const jurisdictionSelect = document.querySelector('#jurisdiction-select');
          const selectedJurisdiction = jurisdictionSelect.value;
          
          const baseUrl = window.location.origin;
          const relinkJurisdictionEndpoint = `${baseUrl}/api/rid-admin/relink-jurisdiction`;
          
          fetch(relinkJurisdictionEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ trackingId, jurisdiction: selectedJurisdiction }),
          })
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
            })
            .then(() => {
              alert('Jurisdiction successfully updated');
              window.location.reload();
            })
            .catch(error => {
              alert('Failed to update jurisdiction. Please try again.');
              console.error(error);
            })
            .finally(() => {
              this.disabled = false;
            });
        });
      }  
    }

    function setupSendReportButtonOnClick() {
      const sendReportButton = document.querySelector('#send-report');

      if(sendReportButton){
        sendReportButton.addEventListener('click', function() {

          const urlParams = new URLSearchParams(window.location.search);
          const trackingId = urlParams.get('trackingId');
  
          const cogNotesTextarea = document.querySelector('.illegal-dumping-report__adminNotes textarea');
          const cogNotes = cogNotesTextarea ? cogNotesTextarea.value : '';
  
          this.disabled = true;
  
          const baseUrl = window.location.origin;
          const updateAdminNotesEndpoint = `${baseUrl}/api/rid-admin/update-admin-notes`;
  
          fetch(updateAdminNotesEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ trackingId, cogNotes }),
          })
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
          })
          .then(() => {
            alert('Report successfully updated');
            window.location.reload();
          })
          .catch(error => {
            alert('Failed to update report. Please try again.', error.message);
          })
          .finally(() => {
            this.disabled = false;
          });
        });
      }   
    }

    function setupSaveButtonOnClicks() {
      const saveButton = document.querySelector('#saveActions');
      const saveAndCloseCaseButton = document.querySelector('#saveAndCloseCase');

      if(saveButton){
        saveButton.addEventListener('click', function() {
          this.disabled = true;
  
          submitActionTakenUpdates.call(this);
        });
      }

      if(saveAndCloseCaseButton){
        saveAndCloseCaseButton.addEventListener('click', function() {
          this.disabled = true;
  
          const actionsTakenTextarea = document.querySelector('.illegal-dumping-report__actionsTaken textarea');
          if (actionsTakenTextarea) {
              const date = new Date();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              const year = date.getFullYear();
              const currentDate = `${month}-${day}-${year}`;
            actionsTakenTextarea.value = actionsTakenTextarea.value + ` Case Closed on ${currentDate}`;
          }
          submitActionTakenUpdates.call(this);
        });
      } 
    }

    function submitActionTakenUpdates(){
      const urlParams = new URLSearchParams(window.location.search);
      const trackingId = urlParams.get('trackingId');
      const actionsTakenElement = document.querySelector('.illegal-dumping-report__actionsTaken');
      const cid = actionsTakenElement ? actionsTakenElement.dataset.cid : '';
      const actionsTakenTextarea = document.querySelector('.illegal-dumping-report__actionsTaken textarea');
      const actionTaken = actionsTakenTextarea ? actionsTakenTextarea.value : '';
      const baseUrl = window.location.origin;
      const saveReportEndpoint = `${baseUrl}/api/rid-admin/update-action-taken`;

      fetch(saveReportEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ trackingId, actionTaken, cid }),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      })
      .then(() => {
        alert('Report successfully saved');
        window.location.reload();
      })
      .catch(error => {
        alert('Failed to save report. Please try again.', error.message);
      })
      .finally(() => {
        this.disabled = false;
      });
    }

    renderStaticMap();

    setupSendReportButtonOnClick();

    setupRelinkJurisdictionButtonOnClick();

    setupDeleteButtonValidation.call(this);

    setupDeleteButtonOnclick();

    setupAddNotesOnBehalfOfButton();

    setupSaveButtonOnClicks();

    setupOutsideRegionButtonValidation.call(this);

    setupOutsideRegionButtonOnclick();
  }
});